<rask-container-block>
    <ng-container header>{{isTerminalorder() ? 'Terminalorderrad' : 'Kundorderrad'}}</ng-container>
    <form class="no-panel-body">
        <rask-kor-hot [canEdit]="canEdit" [kundorderrad]="kundorderrad" [kundorder]="kundorder"></rask-kor-hot>
    </form>
    <ng-container footer>
    </ng-container>
</rask-container-block>
